var _rect, _path, _g, _path2, _g2, _path3, _g3, _path4, _g4, _path5, _g5, _path6, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankKeb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 23,
    rx: 3,
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10824_56109)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10824_56109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 10,
    width: 5,
    height: 4
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1836 13.4554C11.3766 13.5373 11.5787 13.6225 11.7901 13.7109C12.4876 13.2717 13.5711 12.7578 15.2593 11.9991L15.9629 10.8839C13.3118 12.0408 11.973 12.7972 11.1836 13.4554Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10824_56109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1836 13.4554C11.3766 13.5373 11.5787 13.6225 11.7901 13.7109C12.4876 13.2717 13.5711 12.7578 15.2593 11.9991L15.9629 10.8839C13.3118 12.0408 11.973 12.7972 11.1836 13.4554Z",
    fill: "url(#paint0_linear_10824_56109)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_10824_56109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 2,
    width: 15,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33587 11.1024C7.37317 11.1976 7.44292 11.304 7.5538 11.4219C7.95542 10.1772 12.5802 6.4235 20.663 3.36602L21.5191 2.00203C12.1819 5.43862 6.95494 10.102 7.33587 11.1024Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_10824_56109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.33587 11.1024C7.37317 11.1976 7.44292 11.304 7.5538 11.4219C7.95542 10.1772 12.5802 6.4235 20.663 3.36602L21.5191 2.00203C12.1819 5.43862 6.95494 10.102 7.33587 11.1024Z",
    fill: "url(#paint1_linear_10824_56109)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_10824_56109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 8,
    width: 8,
    height: 6
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.9199C10.1765 13.0034 10.3635 13.0893 10.5621 13.1797C11.5347 12.3391 13.3724 11.2481 16.6094 9.84139L17.3498 8.66492C13.1008 10.4698 10.9915 11.8954 10 12.9199Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_10824_56109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 12.9199C10.1765 13.0034 10.3635 13.0893 10.5621 13.1797C11.5347 12.3391 13.3724 11.2481 16.6094 9.84139L17.3498 8.66492C13.1008 10.4698 10.9915 11.8954 10 12.9199Z",
    fill: "url(#paint2_linear_10824_56109)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_10824_56109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 6,
    width: 11,
    height: 7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88672 12.3544C9.06087 12.4497 9.23658 12.5425 9.41379 12.6328C10.5428 11.5203 13.1372 9.70656 17.9615 7.68406L18.742 6.44389C12.8488 8.83691 9.94417 11.1304 8.88672 12.3544Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_10824_56109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.88672 12.3544C9.06087 12.4497 9.23658 12.5425 9.41379 12.6328C10.5428 11.5203 13.1372 9.70656 17.9615 7.68406L18.742 6.44389C12.8488 8.83691 9.94417 11.1304 8.88672 12.3544Z",
    fill: "url(#paint3_linear_10824_56109)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_10824_56109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 4,
    width: 14,
    height: 9
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.92969 11.7547C8.07691 11.8623 8.22817 11.9649 8.38317 12.0625C9.38212 10.7744 12.8659 8.07669 19.3123 5.52716L20.1296 4.22257C12.6237 7.12139 8.74749 10.4043 7.92969 11.7547Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_10824_56109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.92969 11.7547C8.07691 11.8623 8.22817 11.9649 8.38317 12.0625C9.38212 10.7744 12.8659 8.07669 19.3123 5.52716L20.1296 4.22257C12.6237 7.12139 8.74749 10.4043 7.92969 11.7547Z",
    fill: "url(#paint4_linear_10824_56109)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_10824_56109",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 11,
    width: 19,
    height: 10
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56741 11.6932C7.9629 12.7113 11.6076 14.9313 22.6568 19.2381C23.4557 18.9558 24.2461 18.6532 25.0272 18.3305C11.1327 13.9448 7.69566 12.0249 7.33594 11.0989L7.56741 11.6932ZM7.79479 12.2783L7.99126 12.7776C8.4077 13.851 11.4919 16.1791 19.5379 20.1597C20.2458 19.9951 20.9507 19.798 21.639 19.5783C11.7139 15.5483 8.28123 13.2763 7.79836 12.2761L7.79479 12.2783ZM8.2429 13.4259L8.42328 13.8906C8.85761 15.001 11.1807 17.1125 16.6547 20.609C17.2748 20.5698 17.9071 20.4854 18.543 20.3697C11.7921 16.7773 8.7268 14.4604 8.24444 13.4259H8.2429ZM8.70278 14.6081L8.86731 15.0315C9.29141 16.1178 10.6616 17.7094 13.7476 20.4114C14.3073 20.5419 14.8973 20.6132 15.5053 20.6328C11.5195 17.707 9.16674 15.6342 8.70635 14.6081H8.70278ZM9.1767 15.8239L9.32411 16.2004C9.51215 16.6866 9.83866 17.3492 10.204 18.0086C10.8389 18.9584 11.6539 19.6112 12.5923 20.0258C10.8971 18.2472 9.55354 16.6866 9.17926 15.8234L9.1767 15.8239Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_10824_56109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.56741 11.6932C7.9629 12.7113 11.6076 14.9313 22.6568 19.2381C23.4557 18.9558 24.2461 18.6532 25.0272 18.3305C11.1327 13.9448 7.69566 12.0249 7.33594 11.0989L7.56741 11.6932ZM7.79479 12.2783L7.99126 12.7776C8.4077 13.851 11.4919 16.1791 19.5379 20.1597C20.2458 19.9951 20.9507 19.798 21.639 19.5783C11.7139 15.5483 8.28123 13.2763 7.79836 12.2761L7.79479 12.2783ZM8.2429 13.4259L8.42328 13.8906C8.85761 15.001 11.1807 17.1125 16.6547 20.609C17.2748 20.5698 17.9071 20.4854 18.543 20.3697C11.7921 16.7773 8.7268 14.4604 8.24444 13.4259H8.2429ZM8.70278 14.6081L8.86731 15.0315C9.29141 16.1178 10.6616 17.7094 13.7476 20.4114C14.3073 20.5419 14.8973 20.6132 15.5053 20.6328C11.5195 17.707 9.16674 15.6342 8.70635 14.6081H8.70278ZM9.1767 15.8239L9.32411 16.2004C9.51215 16.6866 9.83866 17.3492 10.204 18.0086C10.8389 18.9584 11.6539 19.6112 12.5923 20.0258C10.8971 18.2472 9.55354 16.6866 9.17926 15.8234L9.1767 15.8239Z",
    fill: "url(#paint5_linear_10824_56109)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_10824_56109",
    x1: 11.1008,
    y1: 13.2405,
    x2: 16.1202,
    y2: 11.2842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368482,
    stopColor: "#26A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#26A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631518,
    stopColor: "#26A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_10824_56109",
    x1: 6.6617,
    y1: 9.3847,
    x2: 22.0535,
    y2: 3.38575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368482,
    stopColor: "#26A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#26A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631518,
    stopColor: "#26A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_10824_56109",
    x1: 9.7761,
    y1: 12.3441,
    x2: 17.5963,
    y2: 9.29613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368482,
    stopColor: "#26A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#26A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631518,
    stopColor: "#26A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_10824_56109",
    x1: 8.52275,
    y1: 11.4244,
    x2: 19.0782,
    y2: 7.31047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368482,
    stopColor: "#26A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#26A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631518,
    stopColor: "#26A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_10824_56109",
    x1: 7.42664,
    y1: 10.464,
    x2: 20.5661,
    y2: 5.34286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1F2FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.368482,
    stopColor: "#26A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#26A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.631518,
    stopColor: "#26A9DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D6EA4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_10824_56109",
    x1: 9.63372,
    y1: 16.9925,
    x2: 22.5464,
    y2: 11.9598,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DD224A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155372,
    stopColor: "#902445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#902445"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DD224A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10824_56109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 19,
    fill: "white",
    transform: "translate(7 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankKeb);
export default __webpack_public_path__ + "static/media/BankKEB.86de020675ae027637fc7ea924039671.svg";
export { ForwardRef as ReactComponent };